<template>
  <div
    @click.stop="emit('backdropClicked')"
    class="fixed inset-0 bg-brand-900/20 backdrop-blur-[1px] z-backdrop"
  />
</template>

<script setup>
const emit = defineEmits(["backdropClicked"]);
</script>
